(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('[data-carousel]').forEach((section) => {
    const track = section.querySelector('.card-carousel');
    const previous = section.querySelector('[data-carousel-prev]');
    const next = section.querySelector('[data-carousel-next]');
    if (!track || !previous || !next) return;
    const update = () => {
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    };
    const move = (direction) => {
      const card = track.querySelector('.carousel-card');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 20;
      const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      track.scrollBy({left: direction * step, behavior: reduced.matches ? 'auto' : 'smooth'});
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, {passive: true});
    track.addEventListener('keydown', (event) => {
      if (event.target !== track) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1);
      }
    });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    update();
  });
  const params = new URLSearchParams(window.location.search);
  const message = document.querySelector('textarea[name="contact[body]"]');
  if (params.get('inquiry') === 'custom-garden' && message && !message.value) {
    message.value = 'I would like to arrange a custom garden design meeting.\n\nMy available space (length × width):\nMy preferred layout:\nWhat I would like to grow:\nThe best way to reach me:';
  }
  document.addEventListener('click', event => {
    const menu = document.querySelector('.mobile-nav[open]');
    if (menu && !menu.contains(event.target)) menu.removeAttribute('open');
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const menu = document.querySelector('.mobile-nav[open]');
      if (menu) { menu.removeAttribute('open'); menu.querySelector('summary').focus(); }
    }
  });
})();
